import {
  DocumentTemplateDetailsDocument,
  DocumentTemplateDetailsQuery,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import type { DocumentTemplate } from 'modules/documents/hooks/useGetDocumentTemplates'

import BasicInfo from './BasicInfo'
import DocumentViewer from './DocumentViewer'

type TaskConfigurationSendDocumentTemplate =
  DocumentTemplateDetailsQuery['processes']['taskConfigurationSendDocumentTemplatesConnection']['nodes'][number]

interface Props {
  documentTemplate: DocumentTemplate
  taskConfigurations?: TaskConfigurationSendDocumentTemplate[]
}

const MainContent = ({ documentTemplate, taskConfigurations }: Props) => {
  return (
    <>
      {!documentTemplate.systemTemplate && (
        <BasicInfo documentTemplate={documentTemplate} taskConfigurations={taskConfigurations} />
      )}
      <DocumentViewer documentTemplate={documentTemplate} />
    </>
  )
}

export default observer(MainContent)
